import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';
import CatchImage from '../../images/catch/catch_blog.jpg';
import CatchImage2x from '../../images/catch/catch_blog@2x.jpg';

const ForumAboutPage: React.FC = () => {
  useTitle('Ton Bébé | ドナー募集掲示板とは？');
  useMetaDescription('ドナー募集掲示板とは、ドニーが希望条件を投稿し、条件に合うドナーから応募を受けられる新しいマッチングの仕組みです。使い方や注意点をご紹介します。');

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="ドナー募集掲示板とは？"
          />
        </div>
      </header>
      <main className="sub">
        <section className="forum_about">
          <h1 className="sec_title">ドナー募集掲示板とは？</h1>
          <p>ドナー募集掲示板は、精子提供を希望する方（ドニー）が希望条件を投稿し、条件に合ったドナーから応募を受けられる新しいマッチングの仕組みです。通常のドナー検索とは逆方向のアプローチで、ドニーは「自分から探す」だけでなく「応募を待つ」という選択肢が生まれます。</p>

          <h2 className="main_title"><span>ドニーの利用方法</span></h2>
          <ul className="text_list">
            <li>
              <h3 className="sub_title">1. 募集投稿を作成する</h3>
              <p>希望するドナーの条件（エリア・血液型・年齢・体型・身長）と、あなたの状況や提供方法の希望をコメントに書いて投稿します。募集期間は最大2週間です。</p>
            </li>
            <li>
              <h3 className="sub_title">2. ドナーからの応募を待つ</h3>
              <p>条件に合うと思ったドナーから応募が届きます。応募者のプロフィールや検査結果を確認して、やり取りするか判断しましょう。</p>
            </li>
            <li>
              <h3 className="sub_title">3. メッセージでやり取りを始める</h3>
              <p>気になるドナーとはメッセージ機能で連絡を取り合い、提供方法や日程など諸条件を相談しましょう。</p>
            </li>
          </ul>

          <h2 className="main_title"><span>ドナーの利用方法</span></h2>
          <ul className="text_list">
            <li>
              <h3 className="sub_title">1. 掲示板の投稿を探す</h3>
              <p>ドニーが投稿した募集一覧を見て、ご自身の条件に合いそうな方を探しましょう。</p>
            </li>
            <li>
              <h3 className="sub_title">2. 気になる投稿に応募する</h3>
              <p>「応募する」ボタンから応募します。ドニーがプロフィールを確認し、連絡を取りたいと思ったらメッセージが届きます。</p>
            </li>
          </ul>

          <h2 className="main_title"><span>ご利用にあたって</span></h2>
          <h3 className="sub_title">ドニーの方へ</h3>
          <ul className="notes_list">
            <li>設定した条件に合わないドナーから応募が届く場合があります。応募者のプロフィールをよく確認した上で、やり取りするかご判断ください。</li>
            <li>本文中に連絡先（電話番号・SNSアカウント・メールアドレス等）を直接記載しないでください。やり取りはメッセージ機能をご利用ください。</li>
            <li>個人を特定できる情報（氏名・住所等）は記載しないでください。</li>
            <li>募集の投稿には本人確認の完了が必要です。</li>
          </ul>
          <h3 className="sub_title">ドナーの方へ</h3>
          <ul className="notes_list">
            <li>ドニーからメッセージが届いた場合は、24時間以内にご返信ください。</li>
            <li>応募前に必ずプロフィールの内容（検査結果・エリア等）を最新の状態に更新しておきましょう。</li>
            <li>応募には本人確認の完了と性病検査の提出が必要です。</li>
          </ul>

          <div className="forum-about-cta">
            <h2 className="main_title"><span>さっそく掲示板を使ってみましょう</span></h2>
            <Link to="/forum" className="bluebtn">掲示板を見る</Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ForumAboutPage;
